import PageLayout from "lib/components/PageLayout";
import Wrapper from "lib/components/Wrapper";
import Image from "next/image";
import ImgSoc2Hero from "lib/assets/soc2-hero.png";

export default function SOC2CompliancePage() {
  return (
    <PageLayout>
      <Wrapper>
        <section
          css={`
            margin-bottom: 200px;
            line-height: 24px;
            font-size: 16px;
          `}
        >
          <h1
            css={`
              margin-top: 70px;
              margin-bottom: 28px;
              line-height: 42px;
              font-size: 30px;
              font-weight: bold;
            `}
          >
            Lawfully Levels Up: Now SOC 2 Type II Compliant
          </h1>

          <p
            css={`
              margin-bottom: 32px;
              line-height: 32px;
              font-size: 18px;
              font-style: italic;
              color: #666;
            `}
          >
            Because with great data comes... well, you know the rest.
          </p>

          <div
            css={`
              margin-bottom: 32px;
            `}
          >
            <Image
              src={ImgSoc2Hero}
              alt="SOC 2 Compliance"
              width={1320}
              height={600}
              priority
            />
          </div>

          <h2
            css={`
              margin-top: 40px;
              margin-bottom: 24px;
              font-size: 24px;
              line-height: 32px;
            `}
          >
            We Did the Hard Stuff So You Don&apos;t Have To Worry
          </h2>
          <p>
            When we first started building Lawfully, we knew cool immigration
            tools and slick data insights wouldn&apos;t mean much if people
            couldn&apos;t trust us with their information.
          </p>
          <p>
            So we didn&apos;t just build for speed, features, or design. We
            built for security. And today, we&apos;re proud to say:{" "}
            <strong>Lawfully is officially SOC 2 Type II compliant.</strong>
          </p>
          <p>
            That means we didn&apos;t just <em>talk</em> about being secure (hi,
            Type I). We <em>proved</em> it, over time, under scrutiny, through
            real audits that looked at how we actually operate, not just what we
            say we do.
          </p>

          <div>
            <h2
              css={`
                margin-top: 40px;
                margin-bottom: 24px;
                font-size: 24px;
                line-height: 32px;
              `}
            >
              What That Actually Means
            </h2>

            <p>
              SOC 2 is kind of like the Michelin star of security frameworks for
              U.S. tech companies. Type I says, &quot;Your recipes look
              solid.&quot; Type II says, &quot;We ate here every day for months,
              and it was consistently excellent.&quot;
            </p>
            <p>So yes, we passed the consistency test.</p>
            <p>
              If you&apos;re using the Lawfully app to track your case, or
              Lawfully Pro to manage hundreds of them, this means your data
              lives behind solid walls.
            </p>

            <h2
              css={`
                margin-top: 40px;
                margin-bottom: 24px;
                font-size: 24px;
                line-height: 32px;
              `}
            >
              Trust Is Our Real Product
            </h2>

            <p>
              We track USCIS, NVC, EOIR, and DOL updates, crunch millions of
              case timelines, and help users figure out what&apos;s next. But
              all of that depends on one thing: your trust.
            </p>
            <p>
              This isn&apos;t about checking a compliance box. It&apos;s about
              making sure the foundation behind every &quot;case approved&quot;
              push notification is rock solid.
            </p>

            <h2
              css={`
                margin-top: 40px;
                margin-bottom: 24px;
                font-size: 24px;
                line-height: 32px;
              `}
            >
              What&apos;s Next?
            </h2>

            <p>
              We&apos;re still going. SOC 2 Type II isn&apos;t a finish line.
              It&apos;s a checkpoint.
            </p>

            <p>
              We&apos;ll keep strengthening our systems, tightening up our
              processes, and holding ourselves to high standards. Why? Because
              immigration is stressful enough. You shouldn&apos;t have to wonder
              if your case data is floating around the internet.
            </p>

            <p>
              At Lawfully, we take your trust seriously. Just not ourselves. 😄
            </p>
          </div>
        </section>
      </Wrapper>
    </PageLayout>
  );
}
